import { createContext } from "react";

const SeverityContext = createContext();

export default SeverityContext;